import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LicenseStudyAreas } from 'src/app/predictor-enterprise-license/shared/interface/License-Study-Areas';

@Component({
  selector: 'app-available-study-area',
  templateUrl: './available-study-area.component.html',
  styleUrl: './available-study-area.component.scss',
  standalone: false
})
export class AvailableStudyAreaComponent {

  constructor(
  ) { }

  @Input() licenseStudyAreas!: LicenseStudyAreas[];
  @Input() isClickable!: boolean;
  @Output() selectStudyArea = new EventEmitter<any>();
  @Input() parentClassName: string = '';  // <-
  searchString: string = '';

  searchStringChange(event: any) {
    //// Intentionally left empty
    console.log(event);
  }

  public onStudyAreaClick(selectedArea: any): void {
    this.selectStudyArea.emit(selectedArea);
  }

}
